import React, { useState, useEffect, useRef } from "react";
import "fullpage.js/vendors/scrolloverflow";
import "fullpage.js";
import "fullpage.js/dist/jquery.fullpage.min.css";
import $ from "jquery";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import ArrowsAnimation from "./Arrow";

import AOS from "aos";
import "aos/dist/aos.css";

const AniImg = (props) => {
  return (
    <div
      className="animation__item__img"
      style={{
        // backgroundImage: `url(${"/assets/images/sample1.svg"})`,
        backgroundImage: `url(${props.url})`,
        backgroundColor: `${props.backgroundColor}`,
      }}
    >
      <div
        className="animation__item__text"
        data-aos="fade-up"
        data-aos-duration="500"
        style={{
          color: `${props.color}`,
        }}
      >
        <span dangerouslySetInnerHTML={{ __html: props.text }} />
      </div>
      {/* {props.color === "#000" && (
        <span style={{ position: "relative", right: "0.1%", top: "73%" }}>
          자세히 알아보기
        </span>
      )} */}
      {props.color === "#000" && (
        <div style={{ position: "relative", top: "40%" }}>
          <ArrowsAnimation />
        </div>
      )}
    </div>
  );
};
export default AniImg;
